export const MaxPageWidthString = '100vw';
export const minHorizontalPagePadding = 18;
export const HorizontalPagePaddingString = `clamp(${minHorizontalPagePadding}px, (100vw - 898.617px)*47, 65px)`;
export const topNavigationHeight = 68;
export const topNavigationBorderTopHeight = 4;
export const topNavigationBorderBottomHeight = 1;
export const fullTopNavigationHeight = topNavigationHeight + topNavigationBorderTopHeight + topNavigationBorderBottomHeight;